const SkillTag = ({ children }) => (
  <span className="inline-block bg-indigo-100 text-indigo-800 text-xs font-medium mr-2 mb-1 px-2.5 py-0.5 rounded-full">
    {children}
  </span>
);

export default SkillTag;
